import { useStudentStore } from '@js/stores/student/student';

// The purpose of this method is to refetch the shortlist but only when
// the post request to add/remove has been completed. The reason we are
// using a MutationObserver is because the functionality to add/remove
// shortlist items is handled outside of Vue in jQuery land, so we need
// to listen for changes to the heart icon's data-uh attribute (which
// happens once the request has completed successfully) to know when we
// can refetch the shortlist and have it contain the latest data.
export function observeShortlistAttribute(element) {
  if (!element) {
    return null;
  }

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === 'attributes' && mutation.attributeName === 'data-uh') {
        const attrValue = element.getAttribute('data-uh');

        if (attrValue === 'shortlist-add' || attrValue === 'shortlist-remove') {
          const studentStore = useStudentStore();
          studentStore.invalidateShortlist();
          studentStore.getShortlist();
        }
      }
    });
  });

  observer.observe(element, { attributes: true });

  return observer;
}

